/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/54134348
 */

import React from 'react';
import BootstrapButton from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Row from 'react-bootstrap/Row';
import Tooltip from 'react-bootstrap/Tooltip';
import { includes, isEmpty, isNil, length } from 'ramda';
import Button from '@components/@core/AnimatedButton';
import EditDropdown from '@components/EditDropdown';
import Icon from '@components/@core/Icon';
import FeedList from '@components/LearnFeedList';
import Pagination from '@components/@core/Pagination';
import { UserRoles } from '~/services/config';

const Section = ({ schedules, tracks, userRole, onDetail, onSelect, dataCy }) => {
    let scheduleCourses = 0;
    const scheduleList = schedules.map((schedule, index) => {
        const { id, title, data } = schedule;
        scheduleCourses += isNil(data.cards) ? 0 : length(data.cards);
        return (
            <div className="dsl-p14 section-title p-1 text-400" key={id} onClick={() => onDetail(schedule)}>
                {title}
                {length(schedules) === index + 1 ? '' : ','}&ensp;
            </div>
        );
    });

    let trackCourses = 0;
    const trackList = tracks.map((track, index) => {
        const { id, title, data } = track;
        trackCourses += isNil(data.cards) ? 0 : length(data.cards);
        return (
            <div className="dsl-p14 section-title p-1 text-400" key={id} onClick={() => onDetail(track)}>
                {title}
                {length(tracks) === index + 1 ? '' : ','}&ensp;
            </div>
        );
    });

    const trackMenus = length(tracks) > 0 ? ['Assign', 'Unassign'] : ['Assign'];
    const scheduleMenus = length(schedules) > 0 ? ['Assign', 'Unassign'] : ['Assign'];

    return (
        <div className="assignments-course-section" data-cy={dataCy}>
            <p className="dsl-b18 bold mb-1 sm-font">Schedules & Tracks</p>
            <div className="d-flex ai-center py-3">
                <div className="d-flex-7 dsl-m12 pe-2 text-400">Schedules & Tracks</div>
                <div className="d-flex-2 dsl-m12 me-1 schedules-courses text-end text-400">Courses</div>
                <div className="d-flex-2 dsl-m12 tablet-screen" />
            </div>
            <div className="d-flex ai-center border-top py-4">
                <div className="d-flex d-flex-7 pe-2">
                    <p className="dsl-m14 section-label p-1 text-400">Schedules</p>
                    <div className="d-flex flex-wrap">{length(schedules) > 0 ? scheduleList : <p className="dsl-m14 p-1 mb-0">No assigned schedule.</p>}</div>
                </div>
                <div className="d-flex-2 dsl-b14 text-400 text-end" data-cy="scheduleCourseCount">
                    {scheduleCourses}
                </div>
                <div className="d-flex-2 schedules-courses text-end">
                    {userRole < UserRoles.USER && <EditDropdown dataCy="scheduleCourseDropdown" options={scheduleMenus} onChange={(e) => onSelect(e, schedules, null)} />}
                </div>
            </div>
            <div className="d-flex ai-center border-top py-4">
                <div className="d-flex d-flex-7 pe-2">
                    <p className="dsl-m14 section-label p-1 text-400">Tracks</p>
                    <div className="d-flex flex-wrap">{length(tracks) > 0 ? trackList : <p className="dsl-m14 p-1 mb-0">No assigned track.</p>}</div>
                </div>
                <div className="d-flex-2 dsl-b14 text-end text-400" data-cy="trackCourseCount">
                    {trackCourses}
                </div>
                <div className="d-flex-2 schedules-courses text-end">
                    {userRole < UserRoles.USER && <EditDropdown dataCy="scheduletrackDropdown" options={trackMenus} onChange={(e) => onSelect(e, null, tracks)} />}
                </div>
            </div>
        </div>
    );
};

const tooltip = (
    <Tooltip id="tooltip">
        <span className="dsl-b14">Carry over courses are courses that were assigned in prior months that are still not complete. Please complete them or have your manager archive them.</span>
    </Tooltip>
);

const List = ({ bulkSelect, bulkList, trainings, assignments, userId, userRole, current, total, onPage, onPer, onModal, onSelect, onSelectAllBulks, onBulkSelect, onCancelBulk, onUnassignBulks }) => (
    <>
        <div className="list-view-label">
            <p className="dsl-b18 bold mb-1">Courses</p>
            <div className="list-view-label-contents">
                <div className="w-100 py-3 d-none d-md-flex">
                    <div className="d-flex-5 dsl-m12 text-400">Courses</div>
                    <div className="d-flex-5 d-flex-sm-0 d-h-center">
                        <div className="d-flex-2 dsl-m12 text-end text-400">Modules</div>
                        <div className="d-flex-2 dsl-m12 text-end text-400">Completed</div>
                        <div className="d-flex-2 dsl-m12 text-end text-400">Due</div>
                        <div className="d-none" />
                        <div className="d-flex-4 dsl-m12 text-start text-400 ms-3 ssm-l-0">Status</div>
                        <div className="d-flex-1 dsl-m12 desktop-only" />
                    </div>
                </div>
                {assignments.length === 0 && bulkSelect && (
                    <div className="bulk-unassign">
                        <Button type="link" className="select-all" onClick={onSelectAllBulks}>
                            SELECT ALL
                        </Button>
                    </div>
                )}
            </div>
        </div>
        {assignments && assignments.length !== 0 && (
            <div className="carry-over-section">
                <div className="info-container">
                    <Row className="info jc-end">
                        <OverlayTrigger placement="bottom" overlay={tooltip}>
                            <BootstrapButton>
                                <Icon name="fas fa-info-circle" color="#ff0000" dataCy="openVideoPlayer" size={20} />
                            </BootstrapButton>
                        </OverlayTrigger>
                    </Row>
                    {bulkSelect && (
                        <div className="bulk-unassign">
                            <Button type="link" className="select-all" onClick={onSelectAllBulks}>
                                SELECT ALL
                            </Button>
                        </div>
                    )}
                </div>
                {assignments.map((card, index) => (
                    <FeedList
                        key={card.id}
                        bulk={bulkSelect}
                        course={card}
                        user={userId}
                        userRole={userRole}
                        selected={includes(card.id, bulkList)}
                        onClick={() => onModal(card)}
                        onSelect={(e) => onSelect(e, card)}
                        onBulkSelect={onBulkSelect}
                    />
                ))}
            </div>
        )}
        {trainings.length ? (
            trainings.map((card, index) => (
                <FeedList
                    key={card.id}
                    bulk={bulkSelect}
                    course={card}
                    user={userId}
                    userRole={userRole}
                    selected={includes(card.id, bulkList)}
                    onClick={() => onModal(card)}
                    onSelect={(e) => onSelect(e, card)}
                    onBulkSelect={onBulkSelect}
                />
            ))
        ) : (
            <div className="learn-feed-list" data-cy="noMoreCourseAssigned">
                <div className="border-bottom py-4">
                    <p className="dsl-m14 text-center mb-0">No more courses assigned.</p>
                </div>
            </div>
        )}
        <Pagination current={current} total={total} onChange={onPage} onPer={onPer} />
        {bulkSelect && (
            <div className="d-h-end mt-4">
                <Button type="low" dataCy="cancelBtn" className="mr-4" onClick={onCancelBulk}>
                    CANCEL
                </Button>
                <Button dataCy="unassignBtn" disabled={isEmpty(bulkList)} onClick={onUnassignBulks}>
                    UNASSIGN
                </Button>
            </div>
        )}
    </>
);

export { Section, List };
